<template>
  <div class="content-container">
    <b-loading data-cy="LOADING" isFullPage :active="isLoading" />
    <div
      class="grid-cards"
      :class="{ 'with-productivity': !hiddenProductivity }"
    >
      <article id="card-welcome" class="data-card card-smaller py-10">
        <div class="welcome-text">
          <h1 class="is-size-4 has-text-weight-semibold mb-15">
            {{ `${App.DashboardScreen.WELCOME},  ${userName}` }}!
          </h1>
          <div class="is-size-5">
            <template v-if="version && version.date">
              {{
                App.DashboardScreen.WELCOME_SUBTITLE_VERSION.replace(
                  "(DATA)",
                  version.update_date
                ).replace("(VERSION)", version.version)
              }},
              <a class="custom-link is-underlined" @click="openVersionDetial">
                {{ General.CLICK_HERE.toLowerCase() }}
              </a>
              {{ App.DashboardScreen.WELCOME_SUBTITLE_VERSION_END }}.
            </template>
            <template v-else>
              {{ App.DashboardScreen.WELCOME_SUBTITLE }}
            </template>
          </div>
        </div>
        <figure v-if="!isMobile" class="welcome-img">
          <img :src="welcomeCard" alt="" />
        </figure>
      </article>
      <article
        id="card-view-productivity"
        class="data-card card-smaller py-10"
        @click="hiddenProductivity = !hiddenProductivity"
      >
        <b-icon
          :icon="hiddenProductivity ? 'chart-bar-stacked' : 'arrow-left-thick'"
          size="is-large"
        />
        <h1 class="is-size-6 has-text-weight-semibold mt-10">
          {{
            hiddenProductivity
              ? App.DashboardScreen.SHOW_PRODUCTIVITY
              : App.DashboardScreen.HIDDEN_PRODUCTIVITY
          }}
        </h1>
      </article>
      <article id="card-view-sector" class="data-card card-smaller py-10">
        <h1 class="is-size-5 has-text-weight-semibold mb-10">
          {{ App.DashboardScreen.PANEL_VISION_TYPE }}
        </h1>
        <b-radio
          v-model="viewSector"
          class="has-text-color-7 has-text-weight-semibold"
          :type="isContrast ? 'is-white-dark' : 'is-primary'"
          nativeValue="INDIVIDUAL"
          :disabled="!hasPermissionViewSector"
          @input="value => selectViewSector(value)"
          >{{ General.INDIVIDUAL }}</b-radio
        >
        <b-radio
          v-model="viewSector"
          class="has-text-color-7 has-text-weight-semibold"
          :type="isContrast ? 'is-white-dark' : 'is-primary'"
          nativeValue="SECTOR"
          :disabled="!hasPermissionViewSector"
          @input="value => selectViewSector(value)"
          >{{ General.SECTOR }}</b-radio
        >
        <b-radio
          v-model="viewSector"
          class="has-text-color-7 has-text-weight-semibold"
          :type="isContrast ? 'is-white-dark' : 'is-primary'"
          nativeValue="SECTOR_AND_SUBORDINATES"
          :disabled="!hasPermissionViewSectorAndSubordinates"
          @input="value => selectViewSector(value)"
          >{{ App.DashboardScreen.SECTOR_AND_SUBORDINATES }}</b-radio
        >
      </article>
      <template v-if="hiddenProductivity">
        <article
          id="card-due-date"
          class="data-card clickable"
          :class="{ 'px-10': isMobile }"
          @click.stop="cardSelect('DUE_DATE_PROCESSES')"
        >
          <p class="is-size-5 has-text-weight-semibold">
            {{ App.DashboardScreen.DUE_DATE_PROCESSES }}
          </p>
          <div class="level" :class="{ 'spacing-mb-0': dueDateExpiredCount }">
            <div class="level-left">
              <b-skeleton v-if="dashboardLoad" height="2.5rem" width="2.5rem" />
              <h1 v-else class="is-size-2 has-text-weight-semibold">
                {{ getDashboardInfo.due_date_count }}
              </h1>
            </div>
            <div class="level-right">
              <b-icon icon="clock-time-nine" size="is-large" type="is-orange" />
            </div>
          </div>
          <span v-if="dueDateExpiredCount" class="tag-custom">
            <b-icon icon="alert" size="is-small" class="mr-5" />
            {{ dueDateExpiredCount }}
          </span>
        </article>
        <article
          id="card-urgent"
          class="data-card clickable"
          :class="{ 'px-10': isMobile }"
          @click.stop="cardSelect('URGENT_PROCESSED')"
        >
          <p class="is-size-5 has-text-weight-semibold">
            {{ App.DashboardScreen.URGENT_PROCESSED }}
          </p>
          <div class="level" :class="{ 'spacing-mb-30': dueDateExpiredCount }">
            <div class="level-left">
              <b-skeleton v-if="dashboardLoad" height="2.5rem" width="2.5rem" />
              <h1 v-else class="is-size-2 has-text-weight-semibold">
                {{ getDashboardInfo.urgent_count }}
              </h1>
            </div>
            <div class="level-right">
              <b-icon icon="alert-circle" size="is-large" type="is-red" />
            </div>
          </div>
        </article>
        <article
          id="card-analysis"
          class="data-card clickable"
          :class="{ 'px-10': isMobile }"
          @click.stop="cardSelect('IN_ANALYSIS')"
        >
          <span class="is-size-5 has-text-weight-semibold">
            {{ App.DashboardScreen.PROCESS_ANALISIS }}
          </span>
          <div>
            <div
              class="level"
              :class="{ 'spacing-mb-30': dueDateExpiredCount }"
            >
              <div class="level-left">
                <b-skeleton
                  v-if="dashboardLoad"
                  height="2.5rem"
                  width="2.5rem"
                />
                <h1 v-else class="is-size-2 has-text-weight-semibold">
                  {{ getDashboardInfo.analising_count }}
                </h1>
              </div>
              <div class="level-right">
                <b-icon
                  icon="clipboard-text"
                  size="is-large"
                  :type="isContrast ? 'is-white-dark' : 'is-green-light'"
                />
              </div>
            </div>
          </div>
        </article>
        <article
          v-if="getDashboardInfo.sign_request_count > -1"
          id="card-sign"
          class="data-card clickable"
          :class="{ 'px-10': isMobile }"
          @click.stop="cardSelect('SIGN')"
        >
          <p class="is-size-5 has-text-weight-semibold">
            {{ App.DashboardScreen.DOCUMENTS_TO_SIGN }}
          </p>
          <div class="level" :class="{ 'spacing-mb-30': dueDateExpiredCount }">
            <div class="level-left">
              <b-skeleton v-if="dashboardLoad" height="2.5rem" width="2.5rem" />
              <h1 v-else class="is-size-2 has-text-weight-semibold">
                {{ getDashboardInfo.sign_request_count }}
              </h1>
            </div>
            <div class="level-right">
              <b-icon
                icon="file-document-edit"
                size="is-large"
                :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
              />
            </div>
          </div>
        </article>
        <article
          v-else
          id="card-responsible"
          class="data-card clickable"
          :class="{ 'px-10': isMobile }"
          @click.stop="cardSelect('AWAITING_ANALYSIS')"
        >
          <p class="is-size-5 has-text-weight-semibold">
            {{ App.DashboardScreen.AWAITING_ANALYSIS }}
          </p>
          <div class="level" :class="{ 'spacing-mb-30': dueDateExpiredCount }">
            <div class="level-left">
              <b-skeleton v-if="dashboardLoad" height="2.5rem" width="2.5rem" />
              <h1 v-else class="is-size-2 has-text-weight-semibold">
                {{ getDashboardInfo.without_responsible }}
              </h1>
            </div>
            <b-icon
              icon="account-arrow-right"
              size="is-large"
              type="is-blue-oil"
            />
          </div>
        </article>

        <article id="card-process" class="notification-card">
          <span class="is-size-5 has-text-weight-semibold">
            {{ App.DashboardScreen.PROCESSESS_DUE_DATE }}
          </span>
          <CalendarAppointments
            :processList="getDueDateList"
            :dateMarkList="getDueDateAppointments"
            :onSelect="onChangeDate"
            :load="dashboardDueDateLoad"
          />
        </article>
        <article id="bar-time-processes" class="graph-list">
          <span class="is-size-5 has-text-weight-semibold">
            {{ General.PROCESS_ANALISIS_TIME }}
          </span>
          <div class="title-graph-list">
            <span class="has-text-weight-semibold">{{ General.NUP }}</span>
            <span class="has-text-weight-semibold">{{
              General.DAYS.toUpperCase()
            }}</span>
          </div>
          <section>
            <template v-if="dashboardAnalisesLoad">
              <div v-for="key in 5" :key="`analysis_${key}`" class="mb-10">
                <div class="is-flex is-align-items-flex-end">
                  <b-skeleton height="1rem" width="100%" />
                  <b-skeleton height="1rem" width="20%" position="is-right" />
                </div>
                <b-skeleton height="1rem" width="90%" />
                <b-skeleton v-if="hasSectorView" height="1rem" width="90%" />
              </div>
            </template>
            <template v-else>
              <routerLink
                v-for="process in getProcessAnaliseList"
                :key="process.nup"
                role="link"
                :to="`/app/processos/detalhamento/${process.id}`"
                :class="process.status"
                class="item-list"
              >
                <div>
                  <h1 class="is-size-7 has-text-weight-semibold">
                    {{ applyMaskNUP(process.nup) }}
                  </h1>
                  <p v-if="hasSectorView" class="is-size-7">
                    {{ General.RESPONSIBLE }}: {{ process.name }}
                  </p>
                  <p class="is-size-7">
                    {{ General.SUBJECT }}: {{ process.subject }}
                  </p>
                </div>
                <div>
                  <span class="is-size-5">{{ process.in_analises_days }}</span>
                </div>
              </routerLink>
            </template>
          </section>
        </article>
        <article id="card-signatures" class="graph-list">
          <span class="is-size-5 has-text-weight-semibold">
            {{ App.DashboardScreen.SIGNATURE_PENDING }}
          </span>
          <b-tabs
            v-model="activeSignatureTab"
            :animated="false"
            expanded
            multiline
          >
            <b-tab-item :value="signatureTabs.SIGNING_REQUIRED.value">
              <template slot="header">
                <span class="tabs-title">
                  {{ signatureTabs.SIGNING_REQUIRED.name.toUpperCase() }}
                </span>
              </template>
              <DashboardListSignature
                :signatureList="signaturesReceived"
                :dashboardSignatureLoad="dashboardSignatureLoad"
              />
            </b-tab-item>

            <b-tab-item :value="signatureTabs.SIGNING_REQUESTED.value">
              <template slot="header">
                <span class="tabs-title">
                  {{ signatureTabs.SIGNING_REQUESTED.name.toUpperCase() }}
                </span>
              </template>
              <DashboardListSignature
                :signatureList="signaturesSent"
                :dashboardSignatureLoad="dashboardSignatureLoad"
              />
            </b-tab-item>
          </b-tabs>
        </article>
        <article id="card-messages" class="graph-list">
          <span class="is-size-5 has-text-weight-semibold">
            {{ General.MESSAGE }}
          </span>
          <div class="title-graph-list">
            <span class="has-text-weight-semibold">{{
              App.MessagesAreaScreen.MESSAGE.toUpperCase()
            }}</span>
            <span class="has-text-weight-semibold date-width">{{
              General.DATE.toUpperCase()
            }}</span>
          </div>
          <section>
            <template v-if="dashboardAnalisesLoad">
              <div v-for="key in 5" :key="`analysis_${key}`" class="mb-10">
                <div class="is-flex is-align-items-flex-end">
                  <b-skeleton height="1rem" width="100%" />
                  <b-skeleton height="1rem" width="20%" position="is-right" />
                </div>
                <b-skeleton height="1rem" width="90%" />
                <b-skeleton v-if="hasSectorView" height="1rem" width="90%" />
              </div>
            </template>
            <template v-else>
              <div
                v-for="message in getListMessage"
                :key="message.id"
                class="message-list"
              >
                <div class="flex-1">
                  <h1 class="has-text-weight-semibold">
                    {{ message.title }}
                  </h1>
                  <p>
                    {{ message.description }}
                  </p>
                </div>
                <div class="date-width">
                  {{ new Date(message.created_at) | dateFormat("DD/MM/YYYY") }}
                </div>
              </div>
            </template>
          </section>
        </article>
      </template>
      <template v-else>
        <article id="card-productivity" class="notification-card">
          <b-loading :active="isLoadingProductivity" :isFullPage="false" />
          <article class="columns my-0">
            <div class="productivity-title column is-narrow py-0">
              <span class="is-size-5 has-text-weight-semibold">
                {{
                  hasSectorView
                    ? App.DashboardScreen.SECTOR_PRODUCTIVITY
                    : App.DashboardScreen.MY_PRODUCTIVITY
                }}
              </span>
            </div>
            <section
              class="is-size-7 has-text-weight-semibold column-center column py-0"
            >
              <div class="row-center">
                <div class="box-prod">
                  <span
                    class="spacing-ml-10 is-size-5 has-text-weight-semibold"
                  >
                    {{ productivityPercentage }}
                  </span>
                  <label class="max-font-size"
                    >{{ App.DashboardScreen.RECEIVED_DESPATCH_PRODUCTIVITY }}
                  </label>
                  <label class="max-font-size"
                    >{{ App.DashboardScreen.RECEIVED_DESPATCH }}
                  </label>
                </div>
                <div class="box-prod box-border">
                  <span
                    class="spacing-ml-10 is-size-5 has-text-weight-semibold"
                    >{{
                      (getDashboardProductivity.analysing_media || 0).toFixed(2)
                    }}</span
                  >
                  <span class="max-font-size"
                    >{{ App.DashboardScreen.PROCESS_ANALISIS_TIME }}
                  </span>
                </div>
                <div class="box-prod">
                  <span
                    class="spacing-ml-10 is-size-5 has-text-weight-semibold"
                    >{{ averageTime }}</span
                  >
                  <span class="max-font-size"
                    >{{ App.DashboardScreen.PROCESS_ANALISIS_TIME_AVERAGE }}
                  </span>
                </div>
              </div>
            </section>
          </article>
          <div
            class="is-flex is-justify-content-flex-end is-align-items-center mt-20 mb-5"
          >
            <b-select
              v-model="intervalProductivity"
              class="is-size-7"
              @input="requestProductivity"
            >
              <option
                v-for="option in optionTime"
                :key="option[0]"
                :value="option[0]"
              >
                {{ option[1] }}
              </option>
            </b-select>
          </div>
          <apexchart
            :width="chartWidth"
            height="300"
            :options="areaProductivityOptions"
            :series="areaProductivitySeries"
          />
        </article>
        <article id="bar-part-processes" class="graph-bar">
          <span class="is-size-5 has-text-weight-semibold">
            {{ App.DashboardScreen.PROCESS_RECEIVED_BY_CAPACITY }}
          </span>
          <b-select
            v-model="intervalCapacity"
            class="is-size-7 is-flex is-justify-content-flex-end spacing-mt-10"
            @input="requestCapacities"
          >
            <option
              v-for="option in optionTime"
              :key="option[0]"
              :value="option[0]"
            >
              {{ option[1] }}
            </option>
          </b-select>
          <apexchart
            class="mt-10"
            :width="chartWidth"
            height="245"
            :options="barSectorOptions"
            :series="barSectorOptions.series"
          />
        </article>
        <article id="bar-subject-processes" class="graph-bar">
          <span class="is-size-5 has-text-weight-semibold">
            <span class="has-text-weight-semibold">
              {{ App.DashboardScreen.PROCESS_RECEIVED_BY_SUBJECT }}
            </span>
            <b-select
              v-model="intervalSubject"
              class="is-size-7 is-flex is-justify-content-flex-end spacing-mt-10"
              @input="requestSubject"
            >
              <option
                v-for="option in optionTime"
                :key="option[0]"
                :value="option[0]"
              >
                {{ option[1] }}
              </option>
            </b-select>
          </span>
          <apexchart
            :width="chartWidth"
            height="330"
            :options="barSubjectOptions"
            :series="barSubjectOptions.series"
          />
        </article>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import pt_br from "apexcharts/dist/locales/pt-br.json";

import CalendarAppointments from "@/components/CalendarAppointments";
import DashboardListSignature from "@/components/DashboardListSignature";
import { App, General } from "@/utils/constants";
import welcomeCard from "@/assets/svg/welcome_card.svg";
import { milisecondsToFormatedTime, addZero } from "@/utils/timeUtility";
import ModalVersionDetail from "@/views/App/ModalVersionDetail";
import {
  USER_PERMISSIONS as userPermissions,
  DASHBOARD_VIEW_TYPES as dashboardViewTypes,
  PROCESS_SIGNING_FILE_TABS as signatureTabs,
  DASHBOARD_OPTIONS_TIME as optionsTime,
  PROCESS_PANEL_TABS as PROCESS_PANEL
} from "@/utils/enumerate";
import { NUP, applyMask } from "@/utils/protocols";
import { cleanString } from "@/utils/dataManipulation";
import { truncate } from "lodash";

export default {
  name: "Dashboard",

  components: {
    CalendarAppointments,
    DashboardListSignature
  },

  data() {
    return {
      App,
      General,
      welcomeCard,
      signatureTabs,
      // Chart Baisc

      chartWidth: "99%",
      viewSector: null,
      isLoading: false,
      isLoadingProductivity: false,
      productivityChartRef: null,
      optionTime: Object.entries(optionsTime),
      intervalProductivity: "WEEK",
      intervalSubject: "WEEK",
      intervalCapacity: "WEEK",
      dashboardLoad: false,
      dashboardDueDateLoad: false,
      dashboardAnalisesLoad: false,
      dashboardProductivityLoad: false,
      dashboardSubjectLoad: false,
      dashboardCapacitiesLoad: false,
      dashboardSignatureLoad: false,
      activeSignatureTab: signatureTabs.SIGNING_REQUIRED.value,
      hiddenProductivity: true
    };
  },

  computed: {
    ...mapGetters({
      user: "getCurrentUser",
      getDashboardInfo: "getDashboardInfo",
      getDashboardSubject: "getDashboardSubject",
      getEntityDashboardInfo: "getEntityDashboardInfo",
      getDueDateList: "getDueDateList",
      getDashboardProductivity: "getDashboardProductivity",
      getDashboardDueDate: "getDashboardDueDate",
      getProcessAnalise: "getProcessAnalise",
      getDashboardSignature: "getDashboardSignature",
      getListMessage: "getListMessage",
      hasPermission: "hasPermission",
      version: "getLastVersion",
      getViewSector: "getViewSector",
      isContrast: "isContrast",
      isMobile: "isMobile"
    }),

    hasPermissionProtocoller() {
      return this.hasPermission(userPermissions["PROTOCOLLER"]);
    },

    userName() {
      if (!this.user.name) return "";
      const name = this.user.name.split(" ")[0].toLowerCase();
      return name.charAt(0).toUpperCase() + name.slice(1);
    },

    productivityPercentage() {
      const percent =
        this.getDashboardProductivity.productivity_percentage || 0;
      return ` ${addZero(percent.toFixed(0))}%`;
    },

    dueDateExpiredCount() {
      const value = this.getDashboardInfo.due_date_expired_count;
      const dueText =
        value > 1 ? General.PAST_DUE_PROCESS_PLURAL : General.PAST_DUE_PROCESS;

      return value ? `${addZero(value)} ${dueText}` : value;
    },

    hasPermissionViewSector() {
      return this.hasPermission(userPermissions["SECTOR_VIEW"]);
    },

    hasPermissionViewSectorAndSubordinates() {
      return this.hasPermission(userPermissions["VIEW_SECTOR_AND_CELLS"]);
    },

    hasSectorView() {
      return (
        this.hasPermissionViewSector &&
        dashboardViewTypes[this.viewSector] !== "INDIVIDUAL"
      );
    },

    withChildren() {
      return dashboardViewTypes[this.viewSector] === "SECTOR_AND_SUBORDINATES";
    },

    areaProductivitySeries() {
      const data = { opened: [], analysis: [], analysed: [] };
      if (this.getDashboardProductivity.productivity)
        for (const eachDateValue of this.getDashboardProductivity
          .productivity) {
          const openedValue = [
            eachDateValue.date,
            eachDateValue.count_open_process
          ];
          const analysisValue = [
            eachDateValue.date,
            eachDateValue.count_analysed + eachDateValue.count_analysing
          ];
          const analysedValue = [
            eachDateValue.date,
            eachDateValue.count_analysed
          ];

          data.opened.push(openedValue);
          data.analysis.push(analysisValue);
          data.analysed.push(analysedValue);
        }

      return [
        {
          name: this.App.DashboardScreen.PROCESS_OPENING,
          data: data.opened
        },
        {
          name: this.App.DashboardScreen.PROCESS_FOR_ANALISIS,
          data: data.analysis
        },
        {
          name: this.App.DashboardScreen.PROCESS_TRAMITED_DISPATCH,
          data: data.analysed
        }
      ];
    },

    countIndice() {
      const ref = this.areaProductivitySeries;

      return ref.map(item => ({
        name: item.name,
        value: item.data.reduce((prev, current) => prev + current[1], 0)
      }));
    },

    averageTime() {
      return milisecondsToFormatedTime(
        this.getDashboardProductivity.productivity
          ? this.getDashboardProductivity.productivity[0]
              .avg_permanency_by_period
          : 0,
        "h"
      );
    },

    getDueDateAppointments() {
      const list = this.getDashboardDueDate.due_date_info
        ? this.getDashboardDueDate.due_date_info.map(
            date => new Date(`${date}T23:59:59`)
          )
        : [];

      return list;
    },

    getProcessAnaliseList() {
      const list = this.getProcessAnalise.process_analises
        ? this.getProcessAnalise.process_analises.map(item => ({
            ...item,
            name: this.formatName(item.user_responsible_name || ""),
            subject: truncate(item.subject || "", { length: 100 }),
            status: item.in_analises_days < 15 ? "success" : "warning"
          }))
        : [];

      return list;
    },

    areaProductivityOptions() {
      return {
        chart: {
          locales: [pt_br],
          defaultLocale: "pt-br",
          type: "bar",
          height: 300,
          toolbar: {
            show: true,
            export: {
              csv: {
                filename: undefined,
                columnDelimiter: ";",
                headerCategory:
                  App.DashboardScreen.COLUMN_CATEGORIA_PRODUTIVITY,
                dateFormatter(timestamp) {
                  return new Date(timestamp).toLocaleString("pt-BR");
                }
              }
            }
          },
          background: this.isContrast ? "#1e1e1e" : "#ffffff"
        },

        plotOptions: { bar: { borderRadius: 5 } },
        grid: { padding: { bottom: 20 } },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          onItemHover: {
            highlightDataSeries: true
          }
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeFormatter: {
              hour: ""
            }
          }
        },
        yaxis: {
          title: {
            text: General.PROCESS_PLURAL
          }
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 0.7,
            stops: [50, 100]
          }
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val;
            }
          },
          x: {
            format: "dd MMM yyyy"
          }
        },
        theme: {
          mode: this.isContrast ? "dark" : "light"
        },
        colors: ["#80c470", "#f3915e", "#485465"]
      };
    },

    barSectorOptions() {
      return {
        series: [
          {
            name: General.PROCESS_PLURAL,
            data: this.getEntityDashboardInfo
              ? this.getEntityDashboardInfo.map(item => item.count)
              : []
          }
        ],
        chart: {
          type: "bar",
          height: 300,
          background: this.isContrast ? "#1e1e1e" : "#ffffff"
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: this.getEntityDashboardInfo
            ? this.getEntityDashboardInfo.map(item => item.name)
            : []
        },
        theme: {
          mode: this.isContrast ? "dark" : "light"
        },

        colors: ["#80C470"]
      };
    },
    barSubjectOptions() {
      return {
        series: this.getDashboardSubject.subjects
          ? this.getDashboardSubject.subjects.map(item => item.count)
          : [],

        chart: {
          type: "donut"
        },
        plotOptions: {
          pie: {
            size: 50,
            customScale: 0.8,
            donut: {
              size: "50%",
              labels: {
                show: true,
                name: {
                  formatter: () => General.SUBJECTS
                }
              }
            }
          }
        },
        chartOptions: {
          labels: this.getDashboardSubject.subjects
            ? this.getDashboardSubject.subjects.map(item => item.type)
            : []
        },
        dataLabels: {
          style: {
            fontSize: "20px"
          }
        },
        toolbar: {
          show: false
        },
        legend: {
          show: false
        },
        tooltip: {
          y: {
            formatter: val => val,
            title: {
              formatter: (_, opts) =>
                `${
                  this.getDashboardSubject.subjects
                    ? this.getDashboardSubject.subjects[opts.seriesIndex].type
                    : ""
                } -`
            }
          }
        },
        colors: [
          "#80C470",
          "#65B950",
          "#4B9F37",
          "#358822",
          "#236B13",
          "#909DB2",
          "#697280",
          "#485465",
          "#303F55",
          "#192434"
        ]
      };
    },
    tabLink() {
      return this.hasSectorView
        ? PROCESS_PANEL.SECTOR.value
        : PROCESS_PANEL.IN_ANALYSIS.value;
    },
    signaturesReceived() {
      return this.getDashboardSignature.signatures_received || [];
    },
    signaturesSent() {
      return this.getDashboardSignature.signatures_sent || [];
    }
  },

  watch: {
    viewSector(value) {
      this.setViewSector(value);
      this.hiddenProductivity
        ? this.startDashboard()
        : this.startDashboardProductivity();
    },
    hiddenProductivity(value) {
      value ? this.startDashboard() : this.startDashboardProductivity();
    },
    getViewSector: {
      async handler(value) {
        this.viewSector = value;
      }
    }
  },

  beforeMount() {
    this.viewSector = this.getViewSector;
    this.listMessages();
  },

  mounted() {
    this.chartWidth = "100%";
  },

  methods: {
    ...mapMutations({
      setCurrentTab: "setCurrentTabProcessPanel",
      setViewSector: "setViewSector",
      setViewSectorInbox: "setViewSectorInbox",
      setViewSectorProcessed: "setViewSectorProcessed",
      setViewSectorArchive: "setViewSectorArchive"
    }),

    ...mapActions({
      dashboardRequest: "dashboardRequest",
      dashboardCapacityRequest: "dashboardCapacityRequest",
      dueDateProcessRequest: "dueDateProcessRequest",
      dueDateProcessCapacityRequest: "dueDateProcessCapacityRequest",
      dashboardSubjectRequest: "dashboardSubjectRequest",
      dashboardSubjectCapacityRequest: "dashboardSubjectCapacityRequest",
      dashboardCapacitiesRequest: "dashboardCapacitiesRequest",
      dashboardCapacitiesCapacityRequest: "dashboardCapacitiesCapacityRequest",
      dashboardProductivityRequest: "dashboardProductivityRequest",
      dashboardProductivityCapacityRequest:
        "dashboardProductivityCapacityRequest",
      dashboardDueDateRequest: "dashboardDueDateRequest",
      dashboardDueDateCapacityRequest: "dashboardDueDateCapacityRequest",
      dashboardProcessAnalisesRequest: "dashboardProcessAnalisesRequest",
      dashboardProcessAnalisesCapacityRequest:
        "dashboardProcessAnalisesCapacityRequest",
      dashboardSignatureRequest: "dashboardSignatureRequest",
      listMessages: "listMessages"
    }),
    async onChangeDate(date) {
      const formatedDate = date
        ? {
            day: new Date(date).getDate(),
            month: new Date(date).getMonth() + 1,
            year: new Date(date).getFullYear()
          }
        : null;

      this.hasSectorView
        ? await this.dueDateProcessCapacityRequest({
            ...formatedDate,
            with_children: this.withChildren
          })
        : await this.dueDateProcessRequest(formatedDate);
    },
    async dashboardRequestLoad(options) {
      this.dashboardLoad = true;
      await this[
        this.hasSectorView ? "dashboardCapacityRequest" : "dashboardRequest"
      ]({ with_children: this.withChildren, ...options });
      this.dashboardLoad = false;
    },
    async dashboardDueDateRequestLoad(options) {
      this.dashboardDueDateLoad = true;
      await this[
        this.hasSectorView
          ? "dashboardDueDateCapacityRequest"
          : "dashboardDueDateRequest"
      ]({ with_children: this.withChildren, ...options });
      this.dashboardDueDateLoad = false;
    },
    async dashboardAnalisesRequestLoad(options) {
      this.dashboardAnalisesLoad = true;
      await this[
        this.hasSectorView
          ? "dashboardProcessAnalisesCapacityRequest"
          : "dashboardProcessAnalisesRequest"
      ]({ with_children: this.withChildren, ...options });
      this.dashboardAnalisesLoad = false;
    },
    async dashboardProductivityRequestLoad(options) {
      this.dashboardProductivityLoad = true;
      await this[
        this.hasSectorView
          ? "dashboardProductivityCapacityRequest"
          : "dashboardProductivityRequest"
      ]({ with_children: this.withChildren, ...options });
      this.dashboardProductivityLoad = false;
    },
    async dashboardSubjectRequestLoad(options) {
      this.dashboardSubjectLoad = true;
      await this[
        this.hasSectorView
          ? "dashboardSubjectCapacityRequest"
          : "dashboardSubjectRequest"
      ]({ with_children: this.withChildren, ...options });
      this.dashboardSubjectLoad = false;
    },
    async dashboardCapacitiesRequestLoad(options) {
      this.dashboardCapacitiesLoad = true;
      await this[
        this.hasSectorView
          ? "dashboardCapacitiesCapacityRequest"
          : "dashboardCapacitiesRequest"
      ]({ with_children: this.withChildren, ...options });
      this.dashboardCapacitiesLoad = false;
    },
    async dashboardSignatureRequestLoad(options = {}) {
      this.dashboardSignatureLoad = true;
      await this.dashboardSignatureRequest({
        with_children: this.withChildren,
        sector: this.hasSectorView,
        ...options
      });
      this.dashboardSignatureLoad = false;
    },

    getDate(addDays = 0) {
      const millisecondsPerDay = 86400 * 1000;
      return new Date().getTime() + millisecondsPerDay * addDays;
    },
    cardSelect(tab) {
      const params = {};
      if (tab === "SIGN") return this.$router.push("/app/assinaturas");
      else if (tab === "IN_ANALYSIS" && this.viewSector !== "INDIVIDUAL") {
        this.setCurrentTab("SECTOR");
        params.filters = [
          {
            type: "PROCESS_ANALYSIS",
            data: { displayText: "IN_ANALYSIS" }
          }
        ];
      } else if (
        tab === "AWAITING_ANALYSIS" &&
        this.viewSector !== "INDIVIDUAL"
      ) {
        this.setCurrentTab("SECTOR");
        params.filters = [
          {
            type: "PROCESS_ANALYSIS",
            data: { displayText: "WITHOUT_RESPONSIBLE" }
          }
        ];
      } else if (tab === "DUE_DATE_PROCESSES") {
        this.setCurrentTab(
          this.viewSector === "INDIVIDUAL" ? "IN_ANALYSIS" : "SECTOR"
        );
      } else if (tab === "URGENT_PROCESSED") {
        this.setCurrentTab(
          this.viewSector === "INDIVIDUAL" ? "IN_ANALYSIS" : "SECTOR"
        );
        params.filters = [
          {
            type: "PROCESS_ORDER_BY_URGENT",
            data: { value: true }
          }
        ];
      } else this.setCurrentTab(tab);
      this.selectViewSector(this.viewSector);
      this.$router.push({ name: "Processos", params });
    },
    calcTime(type = "TODAY") {
      let start = new Date();

      if (type === "WEEK") {
        const weekDay = start.getDay();
        start = new Date(Date.now() - weekDay * 24 * 60 * 60 * 1000);
      } else if (type === "MONTH") {
        start = new Date(
          Date.now() - (start.getDate() - 1) * 24 * 60 * 60 * 1000
        );
      } else if (type === "YEAR") {
        start.setDate(1);
        start.setMonth(0);
      }

      const end = new Date(),
        params = {
          day_start: start.getDate(),
          month_start: start.getMonth() + 1,
          year_start: start.getFullYear(),
          day_end: end.getDate(),
          month_end: end.getMonth() + 1,
          year_end: end.getFullYear()
        };

      return params;
    },
    startDashboardProductivity() {
      this.requestSubject();
      this.requestCapacities();
      this.requestProductivity();
    },
    async startDashboard() {
      const paramsInfo = this.calcTime("YEAR");

      this.dashboardRequestLoad(paramsInfo);
      this.dashboardDueDateRequestLoad(paramsInfo);
      this.dashboardAnalisesRequestLoad(paramsInfo);
      this.dashboardSignatureRequestLoad();

      await this.onChangeDate();
    },

    applyMaskNUP(value) {
      return applyMask(NUP, value);
    },

    openVersionDetial() {
      this.$buefy.modal.open({
        parent: this,
        component: ModalVersionDetail,
        props: {
          version: this.version
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    selectViewSector(value) {
      this.setViewSectorProcessed(value);
      this.setViewSectorArchive(value);
      if (value === dashboardViewTypes.INDIVIDUAL)
        this.setViewSectorInbox(dashboardViewTypes.SECTOR);
      else this.setViewSectorInbox(value);
    },

    requestCapacities() {
      this.dashboardCapacitiesRequestLoad({
        ...this.calcTime(this.intervalCapacity),
        with_children: this.withChildren
      });
    },
    requestSubject() {
      this.dashboardSubjectRequestLoad({
        ...this.calcTime(this.intervalSubject),
        with_children: this.withChildren
      });
    },
    requestProductivity() {
      this.dashboardProductivityRequestLoad({
        ...this.calcTime(this.intervalProductivity),
        with_children: this.withChildren
      });
    },
    formatName(name) {
      const formatName = cleanString(name);
      const words = formatName.split(" ");
      return `${words[0]} ${words.pop()}`;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables";

.content-container {
  display: flex;
  flex: 1;
  flex-flow: column;
  width: 100%;
}

.grid-cards {
  display: grid;
  grid-template-areas:
    "card-welcome card-welcome card-view-productivity card-view-sector"
    "card-due-date card-urgent card-analysis card-sign-responsible"
    "card-process card-process bar-time-processes card-signatures"
    "card-messages card-messages card-messages card-messages";
  &.with-productivity {
    grid-template-areas:
      "card-welcome card-welcome card-view-productivity card-view-sector"
      "card-productivity card-productivity bar-part-processes bar-subject-processes";
  }
  grid-template-columns: repeat(4, minmax(0, 1fr));
  width: 100%;
  gap: 25px;

  @media screen and (max-width: 1214px) {
    padding: 0 10px;
    grid-template-areas:
      "card-welcome card-welcome"
      "card-view-productivity card-view-sector"
      "card-due-date card-urgent" "card-analysis card-sign-responsible"
      "card-process card-process" "bar-time-processes bar-time-processes"
      "card-signatures card-signatures"
      "card-messages card-messages";
    &.with-productivity {
      grid-template-areas:
        "card-welcome card-welcome"
        "card-view-productivity card-view-sector"
        "bar-part-processes bar-part-processes"
        "bar-subject-processes bar-subject-processes"
        "card-productivity card-productivity";
    }
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media screen and (max-width: $tablet) {
    margin-top: 10px;
    gap: 15px;
    grid-template-areas:
      "card-welcome card-welcome"
      "card-view-productivity card-view-productivity"
      "card-view-sector card-view-sector"
      "card-due-date card-urgent" "card-analysis card-sign-responsible"
      "card-process card-process" "bar-time-processes bar-time-processes"
      "card-signatures card-signatures"
      "card-messages card-messages card-messages";
    &.with-productivity {
      grid-template-areas:
        "card-welcome card-welcome"
        "card-view-productivity card-view-productivity"
        "card-view-sector card-view-sector"
        "bar-part-processes bar-part-processes"
        "bar-subject-processes bar-subject-processes"
        "card-productivity card-productivity";
    }
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

#card-welcome {
  grid-area: card-welcome;
  display: flex;
  flex-direction: row;
  align-items: stretch;

  .welcome-text {
    display: flex;
    flex-direction: column;
    flex: 2;
  }

  .welcome-img {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 1;
    min-width: 150px;
  }
}

#card-view-productivity {
  grid-area: card-view-productivity;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  &:hover {
    background-color: $color-7;
    color: $color-1;
    cursor: pointer;
  }
}

#card-view-sector {
  grid-area: card-view-sector;
  display: flex;
  justify-content: flex-start;
  gap: 10px;
}

#card-due-date {
  grid-area: card-due-date;
}
#card-urgent {
  grid-area: card-urgent;
}
#card-analysis {
  grid-area: card-analysis;
}
#card-sign {
  grid-area: card-sign-responsible;
}
#card-responsible {
  grid-area: card-sign-responsible;
}
#card-messages {
  grid-area: card-messages;
}

#card-process {
  grid-area: card-process;
}
#card-signatures {
  grid-area: card-signatures;
}
#card-productivity {
  grid-area: card-productivity;
}
#bar-part-processes {
  grid-area: bar-part-processes;
}
#bar-subject-processes {
  grid-area: bar-subject-processes;
}
#bar-time-processes {
  grid-area: bar-time-processes;
}

.data-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 165px;
  width: 100%;
  padding: 25px;
  background-color: $color-1;
  box-shadow: 0 3px 5px 1px #e2e2e2;
  border-radius: 15px;
}

.card-smaller {
  min-height: auto;
}

.clickable {
  cursor: pointer;
  &:hover {
    color: $primary;
  }
}

.level {
  display: flex;
}

.notification-card {
  background-color: $color-1;
  min-width: 355px;
  min-height: 400px;
  padding: 15px;
  box-shadow: 0 3px 5px 1px #e2e2e2;
  border-radius: 15px;
  @media screen and (max-width: $tablet) {
    min-width: 0;
  }

  .productivity-title {
    white-space: nowrap;
  }

  .max-font-size {
    @media screen and (min-width: $tablet) {
      font-size: 11px !important;
    }
  }
}
.graph-list {
  background-color: $color-1;
  min-width: 230px;
  min-height: 200px;
  padding: 15px;
  box-shadow: 0 3px 5px 1px #e2e2e2;
  border-radius: 15px;

  section {
    max-height: 300px;
    overflow-y: auto;
  }
}
.graph-bar {
  background-color: $color-1;
  padding: 15px;
  box-shadow: 0 3px 5px 1px #e2e2e2;
  border-radius: 15px;
}

.title-graph-list {
  display: flex;
  justify-content: space-between;
  background-color: $color-2;
  margin-top: 5px;
  padding: 0px 5px;
}

.date-width {
  width: 80px;
}

.column-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  margin: 0px -10px !important;
}

.row-center {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.item-list {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 5px;
  color: inherit;
  cursor: pointer;
  &:hover {
    color: $green-light;
  }
}

.message-list {
  display: flex;
  flex-direction: row;
  gap: 5px;
  padding: 10px 5px;
  color: inherit;
}

.warning {
  color: $warning;
}

.box-prod {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 10px;
  text-align: center;
}
.box-border {
  border-width: 0px 1px;
  border-style: solid;
  border-color: #b3b3b3b0;
}

.tag-custom {
  color: #fff;
  background-color: $orange;
  border-radius: 15px;
  padding: 5px 15px;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  width: max-content;
}

.tabs-title {
  font-size: 1rem;
  font-weight: bold;
}

.custom-link {
  color: #71ab63;
  cursor: pointer;
  &:hover {
    color: $dark-white;
  }
}
</style>
